const API_BASE_URL =
    process.env.NODE_ENV === "production"
        ? "https://api.giovannisapartments.de" // Produktions-URL
        : "http://localhost:5001"; // Lokale Entwicklungs-URL

export default API_BASE_URL;
